import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DrawerControllerService {
  constructor() {}

  isDrawerOpened = new BehaviorSubject(false);

  toggleDrawer(): void {
    this.isDrawerOpened.next(!this.isDrawerOpened.value);
  }

  getDrawerState(): Observable<boolean> {
    return this.isDrawerOpened.asObservable();
  }
}
